module.exports = __webpack_public_path__ + "img/creator-2.9faa6ab3.png";